import { render, staticRenderFns } from "./Customer-orders.vue?vue&type=template&id=77f7746a"
import script from "./Customer-orders.vue?vue&type=script&lang=js"
export * from "./Customer-orders.vue?vue&type=script&lang=js"
import style0 from "./Customer-orders.vue?vue&type=style&index=0&id=77f7746a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports